import React, {Component, ReactNode} from 'react'
import {Box} from '@mui/material'
import {StyledPre} from '../../../../../styledComponents/adminPage/StyledPre'
import {ApplyCheckbox, InfoArea, InfoOutlinedIcon} from './NatAdminApplicationCommon'

interface Props {
    onChange: (checked: boolean) => void
}

interface State {
    isAccepted: boolean
}

export default class NatAdminApplicationApprovalDirectorDelegateComponent extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            isAccepted: false,
        }
        this.handleChangeWarningCheckBox = this.handleChangeWarningCheckBox.bind(this)
    }

    handleChangeWarningCheckBox(label: string, checked: boolean): void {
        this.setState({isAccepted: checked}, () => {
            this.props.onChange(this.state.isAccepted)
        })
    }

    render(): ReactNode {
        const {isAccepted} = this.state

        return (
            <>
                <Box mb={'16px'}>
                    <StyledPre>
                        申請の承認・却下操作を理事長の代わりに行います。
                    </StyledPre>
                </Box>
                <InfoArea>
                    <Box padding={'20px'}><InfoOutlinedIcon/></Box>
                    <Box>
                        代行で申請の承認または却下を行いますと、処理した内容が記録されます。<br/>
                        間違いがないように操作してください。
                    </Box>
                </InfoArea>
                <Box padding={'19px 19px 0px 0px'}>
                    <ApplyCheckbox
                        data={[{
                            label: '書面などによる理事長の承認判断に基づき、操作を代行します。',
                            checked: isAccepted,
                        }]}
                        onChangeChecked={this.handleChangeWarningCheckBox}
                    />
                </Box>
            </>
        )
    }
}